

function Performance(){  
    return <>

    <div className="CompensationCard">

            <div className="cardHeading"><h2>Performance</h2></div>
            <div className="compensationCard">
                {/* <div className="InpuTsubject"><p><b>Gender</b></p></div>
                <div className="InpuTvalue">Male</div> */}
                <table className="contentTable"> 
                    <thead>
                        <tr>
                            <th>Effective Date</th>
                            <th>Plan Name</th>
                            <th>Plan Type</th>
                            <th>Compensation</th>
                            <th>Assignment</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                             <td>02/08/2022</td>
                             <td>JellyFish Research</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>03/08/2022</td>
                             <td>JellyFish Databases</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>16/08/2022</td>
                             <td>Jopwell Research</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>03/08/2022</td>
                             <td>Interal Leads</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>05/07/2022</td>
                             <td>JBMedia</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>03/08/2022</td>
                             <td>Parrallel Market</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>05/08/2022</td>
                             <td>JBMedia</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>01/08/2022</td>
                             <td>Coffee & Clothes</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                        <tr>
                             <td>01/08/2022</td>
                             <td>Muse</td>
                             <td>Project</td>
                             <td>Monthly Commission - Fulltime</td>
                             <td>2001 ZMK - Monthly</td>
                        </tr>
                      
                    </tbody>
                </table>

            </div>
     
       
    </div>
    

</>

}

export default Performance;